import { OutlinedInfoIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKycLimitRevisionMessaging } from 'hooks/useKycLimitRevisionMessaging';
import routesPath from 'routes/RoutesPath';

interface KycLimitRevisionCardProps {
  className?: string;
  showCta?: boolean;
}

const KycLimitRevisionCard: FC<KycLimitRevisionCardProps> = ({ className = '', showCta = false }) => {
  const navigate = useNavigate();
  const { content, shouldShow } = useKycLimitRevisionMessaging();
  const shouldShowCta = showCta && Boolean(content?.cta);

  if (!shouldShow || !content) {
    return null;
  }

  const handleCtaClick = () => {
    navigate(routesPath.PAYOUTS_SETTINGS);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-start gap-3 rounded-lg border border-[#B7D1E3] bg-[#F3F8FC] px-4 py-3.5 ${className}`}>
      <OutlinedInfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-secondary" aria-hidden />
      <div className="flex min-w-0 flex-col gap-1">
        <div className="text-17px font-semibold leading-snug text-secondary">{content.cardHeader}</div>
        <div className="text-sbase leading-snug text-primaryText">{content.cardBody}</div>
        {shouldShowCta && (
          <CustomButton id="kyc-limit-revision-cta" onClick={handleCtaClick} className="mt-2 h-9 px-4">
            {content.cta}
          </CustomButton>
        )}
      </div>
    </div>
  );
};

export default KycLimitRevisionCard;
